import {
  Modal,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { CloseIcon, InfoIcon } from "../icons";
import { t } from "i18next";
import { stopTrain } from "../services/trainService";
import { QueueItem } from "../@types";
import { toast } from "react-toastify";
import { truncateString } from "common-lib";

const ServerModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "580px",
  height: "300px",
  display: "flex",
  flexDirection: "column",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  userSelect: "none",
};

const ModalHeaderStyle = {
  position: "sticky",
  top: 0,
  backgroundColor: "var(--header-color)",
  zIndex: 1,
  pt: 2,
  pl: 2,
  pr: 2,
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
};

export default function QueueCheckTable({
  projectId,
  selectedQueue,
  setIsStop,
}: {
  projectId?: string;
  selectedQueue: QueueItem[];
  setIsStop: (isStop: boolean) => void;
}) {
  const handleCancel = async (item: QueueItem) => {
    // console.log(item);
    if (window.confirm("해당 학습을 취소하시겠습니까?")) {
      try {
        const response = await stopTrain(item.trainLog_uuid);
        toast.success(response.msg);

        setIsStop(true);
      } catch (error) {
        console.error(error);
      }
    }
  };

  console.log("selectedQueue", selectedQueue);

  return (
    <Box
      sx={{
        maxHeight: 300,
        overflow: "auto",
        p: 1,
        display: "flex",
        width: "100%",
        alignContent: "center",
      }}
    >
      <TableContainer>
        <Table size="small">
          <TableHead sx={{ bgcolor: "var(--scm-table-bgcolor)" }}>
            <TableRow
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
                "& .MuiTableCell-root": {
                  color: "var(--scm-color)",
                },
                height: "40px",
              }}
            >
              <TableCell>Project Name/No</TableCell>
              <TableCell>분류</TableCell>
              <TableCell>학습/검사</TableCell>
              <TableCell>{t("Step")}</TableCell>
              <TableCell>
                <Box
                  sx={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  학습 Class
                  <Tooltip
                    title="통합모델의 경우 별도로 지정되는 Class가 없습니다."
                    arrow
                    placement="top"
                  >
                    <InfoIcon sx={{ fontSize: "20px" }} />
                  </Tooltip>
                </Box>
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {selectedQueue.map((item, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "& .MuiTableCell-root": {
                    color: "var(--text-color)",
                  },
                  "&:nth-of-type(odd)": {
                    backgroundColor: "var(--scm-table-odd-row)",
                  },
                }}
              >
                <Tooltip
                  title={item.project_name || "-"}
                  placement="top"
                  PopperProps={{
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, -25],
                        },
                      },
                    ],
                  }}
                >
                  <TableCell>
                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontSize: "14px",
                        pl: 0.5,
                        border:
                          Number(projectId) === item.project_id
                            ? "solid 1px gray"
                            : "",
                        borderRadius:
                          Number(projectId) === item.project_id ? "5px" : "",
                      }}
                    >
                      {truncateString(item.project_name, 10)}
                    </Typography>
                  </TableCell>
                </Tooltip>
                <TableCell sx={{ fontSize: "14px" }}>
                  {item.multi ? "통합모델" : "단일모델"}
                </TableCell>
                <TableCell>-</TableCell>
                <TableCell>{item.step}</TableCell>
                <TableCell>{item.multi ? "-" : item.class || "-"}</TableCell>
                <TableCell>
                  <Tooltip title="취소">
                    <IconButton
                      onClick={() => {
                        handleCancel(item);
                      }}
                    >
                      <CloseIcon sx={{ fontSize: "18px" }} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
